module.exports = {"name":"dashjs","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.0.1","built":"2017-10-05","repo":"https://bitbucket.org/npaw/dashjs-adapter-js","libVersion":"6.0.8","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getPlayrate","getFramesPerSecond","getDroppedFrames","getDuration","getBitrate","getThroughput","getRendition","getTitle","getTitle2","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 25
// module chunks = 0